export default __webpack_public_path__ + "static/media/top_bg_01_2022_5.2ab8cf3b.png";